import React, { useState } from 'react';
import { Form, Tooltip, Row, Col, Table, Checkbox, Typography, InputNumber } from "antd";
import { FullHeightContainerLayout, BusinessAreaApiKeyChangedAttributes } from "components";
import moment from 'moment';
import _ from 'lodash';

const { Column } = Table;
const { Title, Text, Link } = Typography;

const BusinessAreaApiKeyHistoryList = ({ businessAreaApiKeyRevisions }) => {
    const [recordDetail, setRecordDetail] = useState(null);
    const [containerHeight, setContainerHeight] = useState("100%");
    return (
        <Row style={{ flexDirection: "column", flexGrow: 1, height: "100%" }}>
            <Col span={24} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <Row style={{ flexDirection: "column", flexGrow: 1, height: containerHeight }}>
                    <Col span={24}>
                        <FullHeightContainerLayout
                            content={<Table size="small"
                                rowKey="data.apiKey.apiKeyId"
                                dataSource={businessAreaApiKeyRevisions}
                                pagination={false}
                                scroll={{ y: `100vh` }}
                                className={"container-height-100"}>
                                <Column
                                    width="5rem"
                                    title="No."
                                    key="index"
                                    render={(value, businessAreaApiKeyRevision, index) => index + 1}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "apiKey", "name"]}
                                    title={"API Key"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, businessAreaApiKeyRevision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "apiKey", "apiKeyId"]}
                                    title={"API Key Id"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, businessAreaApiKeyRevision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="5rem"
                                    title={"Add"}
                                    dataIndex={["data", "apiKey", "canAdd"]}
                                    render={(value, businessAreaApiKeyRevision, index) => <Checkbox disabled={true} checked={value}></Checkbox>}
                                />
                                <Column
                                    width="5rem"
                                    title={"View"}
                                    dataIndex={["data", "apiKey", "canView"]}
                                    render={(value, businessAreaApiKeyRevision, index) => <Checkbox disabled={true} checked={value}></Checkbox>}
                                />
                                <Column
                                    width="5rem"
                                    title={"Edit"}
                                    dataIndex={["data", "apiKey", "canEdit"]}
                                    render={(value, businessAreaApiKeyRevision, index) => <Checkbox disabled={true} checked={value}></Checkbox>}
                                />
                                <Column
                                    width="5rem"
                                    title={"Delete"}
                                    dataIndex={["data", "apiKey", "canDelete"]}
                                    render={(value, businessAreaApiKeyRevision, index) => <Checkbox disabled={true} checked={value}></Checkbox>}
                                />
                                <Column
                                    width="5rem"
                                    title={"Active"}
                                    dataIndex={["data", "apiKey", "active"]}
                                    render={(value, businessAreaApiKeyRevision, index) => <Checkbox disabled={true} checked={value}></Checkbox>}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "createdByEmail"]}
                                    title={"Created By"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, businessAreaApiKeyRevision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "createdDate"]}
                                    title={"Created Date"}
                                    render={(value, businessAreaApiKeyRevision, index) => <>{moment.utc(value).toDate().toLocaleString()}</>}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "updatedByEmail"]}
                                    title={"Updated By"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, businessAreaApiKeyRevision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="15rem"
                                    dataIndex={["data", "updatedDate"]}
                                    title={"Updated Date"}
                                    render={(value, businessAreaApiKeyRevision, index) => <>{moment.utc(value).toDate().toLocaleString()}</>}
                                />
                                <Column
                                    width="12rem"
                                    dataIndex={"changes"}
                                    title={"Changes"}
                                    render={(value, businessAreaApiKeyRevision, index) => {
                                        if (value) {
                                            return <>
                                                {Object.keys(value).reduce((items, key) => {
                                                    if (Object.keys(value[key]).length > 0) {
                                                        items.push(<Row key={key}>
                                                            <Col>
                                                                <Link onClick={() => {
                                                                    setContainerHeight("50%");
                                                                    setRecordDetail({
                                                                        name: `${_.capitalize(key)} attributes`,
                                                                        recordId: businessAreaApiKeyRevision.data.apiKey.apiKeyId,
                                                                        data: value[key],
                                                                        previousData: businessAreaApiKeyRevision.previousChanges && businessAreaApiKeyRevision.previousChanges[key]
                                                                    });
                                                                }}>
                                                                    {`${key} attributes`}
                                                                </Link>
                                                            </Col>
                                                        </Row>);
                                                    }
                                                    return items;
                                                }, [])}
                                            </>
                                        }
                                        return <></>;
                                    }}
                                />
                            </Table>}>
                        </FullHeightContainerLayout>
                    </Col>
                </Row>
                {
                    recordDetail
                        ?
                        <Row style={{ flexDirection: "column", flexGrow: 1, height: containerHeight }}>
                            <Col span={24}>
                                <FullHeightContainerLayout
                                    showHeader={false}
                                    content={<BusinessAreaApiKeyChangedAttributes key={recordDetail.recordId} record={recordDetail}></BusinessAreaApiKeyChangedAttributes>}
                                    showFooter={false}>
                                </FullHeightContainerLayout>
                            </Col>
                        </Row>
                        :
                        <></>}
            </Col>
        </Row>
    );
}

export default BusinessAreaApiKeyHistoryList;